import React, { useEffect, useMemo, useState } from "react";
import { Modal, Table, Spinner, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { LINEAR_GRADIENT_BG, SHOP_SETTING_KEY } from "../../const";
import { GET_SUVIVALS } from "../../apollo/unit/Query";
import { useLazyQuery } from "@apollo/client";
import { numberFormat } from "../../helper";

export default function PurchaseFabricModal({
  SetshowOrderModal,
  showOrderModal,
  cartDatas,
  setCartDatas,
  createPurchaseorderLoading,
  onClearOrder,
  onCreateManyPurchaseOrderWithPurchaseOrderDetail,
}) {
  const [getSurvival, { loading: loadingSurvival, data: survivalData }] = useLazyQuery(GET_SUVIVALS, { fetchPolicy: "cache-first" });
  const [searchLot, setSearchLot] = useState({});
  
  const lots = useMemo(() => survivalData?.survivals?.data || [], [survivalData]);
  const shopSetting = useMemo(() => JSON.parse(localStorage.getItem(SHOP_SETTING_KEY)) || {}, []);

  useEffect(() => {
    const controller = new AbortController();
    const fetchSurvivalData = async () => {
      try {
        const userData = localStorage.getItem("SHOP_DATA");
        const locals = JSON.parse(userData);
        if (!locals) return;
        await getSurvival({
          variables: {
            where: { shop: locals?.id || "", status: true, isDeleted: false },
          },
          context: { fetchOptions: { signal: controller.signal } },
        });
      } catch (error) {
        if (error.name !== 'AbortError') console.error('Error:', error);
      }
    };
    fetchSurvivalData();
    return () => controller.abort();
  }, [getSurvival]);

  console.log("cartDatas :",cartDatas);
  

  const handleEditFabric = (val, cIndex, oIndex, field) => {
    const newProduct = [...cartDatas];
    const target = newProduct[cIndex]?.data?.orders[oIndex];
    const qtyPerRoll = target.qtyPerRoll || 0;

    if (field === "amountRoll") {
      target.amountRoll = val;
      target.amount = val;
      target.totalQty = Math.round(val * qtyPerRoll);
      target.totalPrice = val * (target.originPricePerRoll || 0);
    } else if (field === "qtyPerRoll") {
      target.qtyPerRoll = val;
      target.totalQty = Math.round((target.amountRoll || 0) * val);
      // Recalculate unit prices if qtyPerRoll changes
      if (val > 0) {
        target.originPrice = Math.ceil((target.originPricePerRoll || 0) / val);
        target.price = Math.ceil((target.pricePerRoll || 0) / val);
      }
    } else if (field === "totalQty") {
      target.totalQty = val;
      if (qtyPerRoll > 0) {
        target.amountRoll = val / qtyPerRoll;
        target.amount = target.amountRoll;
        target.totalPrice = Math.ceil(target.amountRoll * (target.originPricePerRoll || 0));
      }
    } else if (field === "originPricePerRoll") {
      target.originPricePerRoll = val;
      if (qtyPerRoll > 0) {
        target.originPrice = Math.ceil(val / qtyPerRoll);
      }
      target.totalPrice = Math.ceil((target.amountRoll || 0) * val);
    } else if (field === "pricePerRoll") {
      target.pricePerRoll = val;
      if (qtyPerRoll > 0) {
        target.price = Math.ceil(val / qtyPerRoll);
      }
    } else if (field === "originPrice") {
      target.originPrice = val;
      target.originPricePerRoll = Math.ceil(val * qtyPerRoll);
      target.totalPrice = (target.amountRoll || 0) * target.originPricePerRoll;
    } else if (field === "price") {
      target.price = val;
      target.pricePerRoll = Math.ceil(val * qtyPerRoll);
    } else {
      target[field] = val;
    }
    setCartDatas(newProduct);
  };

  return (
    <Modal show={showOrderModal} onHide={() => SetshowOrderModal(false)} size="xl" backdrop="static" centered>
      <Modal.Header closeButton className="py-2">
        <div className="d-flex w-100 align-items-center">
          <div className="w-50"><Modal.Title>ລາຍການສັ່ງຊື້ຜ້າ</Modal.Title></div>
          <div className="w-50 ps-2">
            <Form.Select
              className="form-select py-2"
              onChange={(e) => {
                const selectedLot = lots?.find(lot => lot?.id === e.target.value);
                setSearchLot(selectedLot);
                let newProduct = [...cartDatas];
                newProduct[0].lot = e.target.value;
                setCartDatas(newProduct);
              }}
            >
              {loadingSurvival ? <option>Loading...</option> : (
                <>
                  <option value="ALL">ລ໊ອດທັງໝົດ</option>
                  {lots?.map((lot, idx) => <option key={idx} value={lot?.id}>{lot?.survivalNumber}</option>)}
                </>
              )}
            </Form.Select>
          </div>
        </div>
      </Modal.Header>
      
      <Modal.Body className="p-2">
        <div className="table-responsive">
          <Table hover className="w-100" style={{ borderRadius: "8px" }}>
            <thead style={{ background: LINEAR_GRADIENT_BG, color: "#FFFFFF" }}>
              <tr>
                <th className="py-2 text-center" style={{ width: "40px" }}>ລ/ດ</th>
                <th className="py-2" style={{ width: "100px" }}>ລ໊ອດ</th>
                <th className="py-2">ຊື່ຜ້າ</th>
                <th className="py-2 text-center" style={{ width: "170px" }}>ຈຳນວນກໍ້</th>
                <th className="py-2" style={{ width: "100px" }}>ຈ/ນເສື້ອ/ກໍ້</th>
                <th className="py-2" style={{ width: "110px" }}>ຈ/ນທັງໝົດ</th>
                <th className="py-2" style={{ width: "120px" }}>ຕົ້ນທຶນ/ກໍ້</th>
                <th className="py-2" style={{ width: "120px" }}>ລາຄາຂາຍ/ກໍ້</th>
                <th className="py-2" style={{ width: "120px" }}>ລາຄາລວມ</th>
                <th className="py-2 text-center" style={{ width: "50px" }}></th>
              </tr>
            </thead>
            <tbody>
              {cartDatas?.map((cart, cIndex) =>
                cart?.data?.orders?.map((order, oIndex) => (
                  <tr key={oIndex} className="align-middle">
                    <td className="py-2 text-center">{oIndex + 1}</td>
                    <td className="py-2">{searchLot?.survivalNumber ?? '...'}</td>
                    <td className="py-2">
                      <div className="fw-bold text-primary">{order?.productName}</div>
                      <small className="text-muted">ID: {order?.fabric?.substring(0, 8)}...</small>
                    </td>
                    <td className="py-2">
                      <div className="d-flex align-items-center justify-content-center gap-1">
                        <CustomButton
                          onClick={() => {
                            const current = order?.amountRoll ?? 0;
                            if (current <= 1) return onClearOrder(order);
                            handleEditFabric(current - 1, cIndex, oIndex, "amountRoll");
                          }}
                          icon={<RemoveIcon />}
                          width="28px"
                          height="28px"
                          background="#6B7280"
                          borderRadius="4px"
                        />
                        <Form.Control
                          type="number"
                          className="px-1 text-center font-weight-bold"
                          min="0"
                          value={order?.amountRoll ?? 0}
                          onChange={(e) => handleEditFabric(parseFloat(e.target.value || 0), cIndex, oIndex, "amountRoll")}
                          style={{ width: "60px", height: "32px", fontSize: "14px" }}
                        />
                        <CustomButton
                          onClick={() => handleEditFabric((order?.amountRoll ?? 0) + 1, cIndex, oIndex, "amountRoll")}
                          icon={<AddIcon />}
                          width="28px"
                          height="28px"
                          background="#6B7280"
                          borderRadius="4px"
                        />
                      </div>
                    </td>
                    <td className="py-2 text-center">
                      <Form.Control
                        type="number"
                        min="0"
                        className="text-center"
                        value={order?.qtyPerRoll ?? 0}
                        onChange={(e) => handleEditFabric(parseFloat(e.target.value || 0), cIndex, oIndex, "qtyPerRoll")}
                        style={{ width: "80px", height: "32px", fontSize: "14px" }}
                      />
                    </td>
                    <td className="py-2 text-center">
                      <Form.Control
                        type="number"
                        min="0"
                        className="text-center bg-light"
                        value={order?.totalQty ?? 0}
                        readOnly
                        style={{ width: "90px", height: "32px", fontSize: "14px", fontWeight: "bold" }}
                      />
                    </td>
                    <td className="py-2">
                      <Form.Control
                        type="number"
                        min="0"
                        className="text-end"
                        value={order?.originPricePerRoll ?? 0}
                        onChange={(e) => handleEditFabric(parseFloat(e.target.value || 0), cIndex, oIndex, "originPricePerRoll")}
                        style={{ width: "110px", height: "32px", fontSize: "14px" }}
                      />
                    </td>
                    <td className="py-2">
                      <Form.Control
                        type="number"
                        min="0"
                        className="text-end"
                        value={order?.pricePerRoll ?? 0}
                        onChange={(e) => handleEditFabric(parseFloat(e.target.value || 0), cIndex, oIndex, "pricePerRoll")}
                        style={{ width: "110px", height: "32px", fontSize: "14px" }}
                      />
                    </td>
                    <td className="py-2 text-end fw-bold">
                      {numberFormat(order?.totalPrice ?? 0)}
                      <div style={{ fontSize: "10px", color: "#6B7280" }}>LAK</div>
                    </td>
                    <td className="py-2 text-center">
                      <CustomButton onClick={() => onClearOrder(order)} title="ລົບ" width="40px" height="30px" background="#dc3545" color="#fff" borderRadius="4px" />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      
      <Modal.Footer className="py-2">
        <CustomButton width={130} height={38} background="transparent" color="#3C169B" border="1px solid #3C169B" title="ຍົກເລີກ" onClick={() => SetshowOrderModal(false)} />
        <CustomButton width={130} height={38} background={LINEAR_GRADIENT_BG} title={createPurchaseorderLoading ? <Spinner size="sm" /> : "ຢືນຢັນ"} onClick={onCreateManyPurchaseOrderWithPurchaseOrderDetail} disabled={createPurchaseorderLoading} className="ms-3" />
      </Modal.Footer>
    </Modal>
  );
}
